import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import success_icon from "../../../../../Assets/svg/success_icon.svg";
import { Link } from "react-router-dom";

const SuccessPage = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center h-100">
      <img
        src={success_icon}
        alt="Success"
        className="response-page mt-5"
        height={100}
      />
      <h1 className="text-success">Payment Successful!</h1>
      <p className="text-center mb-4">
        Thank you for your purchase! Your payment has been processed
        successfully.
      </p>
      <Link to="/home">
        <Button
          variant="primary"
          className="d-flex align-items-center w-100 justify-content-center commonBtn"
        >
          Go to Dashboard
        </Button>
      </Link>
    </div>
  );
};

export default SuccessPage;
